import React, {useEffect, useState} from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import Navbar from "./components/Navbar";
import {useSelector} from "react-redux";
import Home from "./pages/Home";
import ProjectDetails from "./pages/ProjectDetails";
import Wallpapers from './pages/Wallpapers';
import Login from './pages/Login';
import Admin from './pages/Admin';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

const ProtectedRoute = ({ children }) => {
    const [isChecking, setIsChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const [token, setToken] = useState(null);
    const API_URL = process.env.NODE_ENV === 'production' ? '/api' : (process.env.REACT_APP_API_URL || 'http://localhost:8080');

    useEffect(() => {
        const verifyToken = async () => {

            const currentToken = localStorage.getItem('token');

            if (!currentToken) {
                setIsAuthenticated(false);
                setIsChecking(false);
                return;
            }

            try {
                const response = await fetch(`${API_URL}/admin/auth/validate`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${currentToken}`
                    }
                });

                if (response.status === 204) {
                    setIsAuthenticated(true);
                    setToken(currentToken)
                } else {
                    localStorage.removeItem('token');
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error('Errore durante la convalida del token:', error);
                setIsAuthenticated(false);
            } finally {
                setIsChecking(false);
            }
        };

        verifyToken();
    }, [token, API_URL]);

    if (isChecking) {
        return (
            <div className="min-h-screen bg-earth-50 dark:bg-earth-900 flex items-center justify-center">
                <div className="flex flex-col items-center gap-3">
                    <svg className="animate-spin h-8 w-8 text-earth-600 dark:text-earth-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className="text-earth-800 dark:text-earth-200 font-medium text-sm animate-pulse">
                        Verifica sessione...
                    </span>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

function App() {

    const {darkMode} = useSelector(state => state.darkMode)

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
    }, [darkMode])

    return (
        <BrowserRouter>
            <Navbar/>
            <Routes>
                <Route
                    path="/"
                    element={<Home/>}
                />
                <Route
                    path="/projects/:slug"
                    element={<ProjectDetails/>}
                />
                <Route
                    path="/wallpapers"
                    element={<Wallpapers/>}
                />
                <Route
                    path="/privacy"
                    element={<Privacy/>}
                />
                <Route
                    path="/terms"
                    element={<Terms/>}
                />
                <Route
                    path="/login"
                    element={<Login/>}
                />
                <Route
                    path="/admin"
                    element={
                        <ProtectedRoute>
                            <Admin/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path='/searchByName'
                    element={<div/>}
                />
                <Route
                    path='/drink/:strDrink'
                    element={<div/>}
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
